module.exports = __webpack_public_path__ + "calendar-today-outline.rgPfyywK.svg";